import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { Api } from "./../app-controller.js";
import { useAuth } from "../components/content/auth.jsx";
//import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
//import classnames from 'classnames';
//import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Swal from "sweetalert2";

import Leaflet from "leaflet";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";

Leaflet.Icon.Default.imagePath = "../node_modules/leaflet";

delete Leaflet.Icon.Default.prototype._getIconUrl;

Leaflet.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

class EstablishmentInscription extends React.Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleStep = this.handleStep.bind(this);
    //this.handleTipoEstablecimiento = this.handleTipoEstablecimiento.bind(this);
    this.handleDepartamentos = this.handleDepartamentos.bind(this);
    this.handleMunicipios = this.handleMunicipios.bind(this);
    this.handlePais = this.handlePais.bind(this);
    this.handleActividades = this.handleActividades.bind(this);
    this.handleCondiciones = this.handleCondiciones.bind(this);
    this.handleRepresentante = this.handleRepresentante.bind(this);
    this.addRep = this.addRep.bind(this);
    this.removeRep = this.removeRep.bind(this);

    this.handleRegente = this.handleRegente.bind(this);
    this.handleGuidRegente = this.handleGuidRegente.bind(this);
    this.handleExisteRegente = this.handleExisteRegente.bind(this);
    this.removeReg = this.removeReg.bind(this);

    this.handleEstablecimiento = this.handleEstablecimiento.bind(this);
    this.handleGuidEstablecimiento = this.handleGuidEstablecimiento.bind(this);
    this.handleExisteEstablecimiento =
      this.handleExisteEstablecimiento.bind(this);
    this.removeEst = this.removeEst.bind(this);

    this.handleWarning = this.handleWarning.bind(this);
    this.handleLatLong = this.handleLatLong.bind(this);
    this.handleLat = this.handleLat.bind(this);
    this.handleLng = this.handleLng.bind(this);
    this.handleDireccion = this.handleDireccion.bind(this);
    this.maxLengthCheck = this.maxLengthCheck.bind(this);
    this.buscarUbicacion = this.buscarUbicacion.bind(this);

    this.handleTelefonoNacional = this.handleTelefonoNacional.bind(this);
    this.handleTelefonoExtranjero = this.handleTelefonoExtranjero.bind(this);
    this.validatePhoneNumber = this.validatePhoneNumber.bind(this);
    this.handleAreaTotal = this.handleAreaTotal.bind(this);
    this.validateIdentificationNumber =
      this.validateIdentificationNumber.bind(this);

    this.state = {
      id: this.props.match.params["id"],
      nacional: "",
      tipo_establecimiento_id: "",
      actividad_id: null,
      actividades: [],
      pais: "",
      activeStep: "establecimiento",
      //docsRequired: [],
      recs: [],
      wizzard: [
        {
          titulo: "Establecimiento",
          descripcion: "Datos del establecimiento",
          estado: "active ",
        },
        {
          titulo: "Representante Legal",
          descripcion: "Datos del representante legal",
          estado: "disabled",
        },
        {
          titulo: "Regente",
          descripcion: "Información del regente",
          estado: "disabled",
        },
        {
          titulo: "Establecimientos relacionados",
          descripcion: "Establecimientos relacionados con el actual",
          estado: "disabled",
        },
        {
          titulo: "Características",
          descripcion: "Características del establecimiento",
          estado: "disabled",
        },
      ],
      options_identification: {
        tipo_identificacion: Api.loadCatalogue("cat_tipo_documento"),
      },
      options_conditions: { condiciones: Api.loadCatalogue("cat_condicion") },
      options_locations: Api.loadCatalogue("locations"),
      option_paises: Api.loadCatalogue("countries"),
      telefono: "",
      lada: "+",
      correo_electronico: "",
      departamento_id: "",
      departamento_name: "",
      municipio_id: "",
      municipio_name: "",
      razon_social: "",
      area: "",
      direccion: "",
      direccion_bodegas: "",
      condiciones: [],
      procesando: false,
      numero_de_identificacion: "",
      disabledR: false,
      //existe_regente: false, //verifica que se lleno y valido la parte de regente
      latitud: 12.13282,
      latitudVal: 12.13282,
      longitud: -86.2504,
      longitudVal: -86.2504,
      representante_legal: {
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        direccion: "",
        tipo_documento_id: "", //tipo identificacion
        numero_identificacion: "",
        telefono: "",
        email: "",
        departamento_id: "",
        municipio_id: "",
      },
      regente: {
        regente_id: "",
        nombres: "",
        apellido_paterno: "",
        apellido_materno: "",
        guid: "",
      },
      establecimiento: {
        establecimiento_id: "",
        razon_social: "",
        guid: "",
      },
      regentes: [],
      representantes: [],
      establecimientos: [],
      latLongDir: "",
    };
  }

  componentDidMount() {
    Api.loadCatalogue("countries");
    let identificacion = Api.loadCatalogue("cat_tipo_documento");
    let ids = [];
    for (let id in identificacion) {
      if (identificacion[id].id === "1" || identificacion[id].id === "2") {
        ids.push(identificacion[id]);
      }
    }
    this.setState({ options_identification: { tipo_identificacion: ids } });

    Api.fetch("app/getNacionalDSE?id=" + this.props.match.params["id"]).then(
      (data) => {
        if (data) {
          this.setState({
            nacional: data.nacional,
            tipo_establecimiento_id: data.tipo_establecimiento_id,
            actividad_id: data.actividad_id || null,
            actividades: data.actividad_id ? [String(data.actividad_id)] : [],
          });
        }
      }
    );
  }

  addRep(e) {
    let reps = [];
    let data = Api.serialize(document.getElementById("frmRep"));
    reps = this.state.representantes;

    let locs = Api.loadCatalogue("locations");
    let deps = locs.departamentos;
    let muns = locs.municipios;
    let pass = 1;

    if (data) {
      if (data.municipio_id === "Seleccione") {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de seleccionar un municipio",
        });
        pass = 0;
      }

      if (data.departamento_id === "Seleccione") {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de seleccionar un departamento",
        });
        pass = 0;
      }

      if (data.email === "" || !data.email) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar correo electrónico",
        });
        pass = 0;
      }

      if (data.telefono === "" || !data.telefono) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar teléfono activo",
        });
        pass = 0;
      }

      if (data.numero_identificacion === "" || !data.numero_identificacion) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar su número de identificación",
        });
        pass = 0;
      }

      if (data.tipo_documento_id === "Seleccione") {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de seleccionar el tipo de identificación",
        });
        pass = 0;
      }

      if (data.direccion === "" || !data.direccion) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar una dirección",
        });
        pass = 0;
      }

      /*       if (data.apellido_materno === "" || !data.apellido_materno) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar apellido materno",
        });
        pass = 0;
      } */

      if (data.apellido_paterno === "" || !data.apellido_paterno) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar apellido paterno",
        });
        pass = 0;
      }

      if (data.nombres === "" || !data.nombres) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar nombre(s)",
        });
        pass = 0;
      }

      if (pass) {
        data["ubicacion"] =
          deps[deps.findIndex((x) => x.id.toString() === data.departamento_id)]
            .name +
          ", " +
          muns[muns.findIndex((x) => x.id.toString() === data.municipio_id)]
            .name;

        reps.push(data);

        this.setState({ representantes: reps });

        let representante = {
          nombres: "",
          apellido_paterno: "",
          apellido_materno: "",
          direccion: "",
          tipo_documento_id: "",
          numero_identificacion: "",
          telefono: "",
          email: "",
          departamento_id: "",
          municipio_id: "",
        };
        this.setState({ representante_legal: representante });
      }
    }
  }

  removeRep(e) {
    let representantes = [...this.state.representantes];
    representantes.splice(e.target.id, 1);
    this.setState({ representantes: representantes });
  }

  buscarUbicacion(e) {
    let departamento = this.state.departamento_name,
      municipio = this.state.municipio_name,
      pais = this.state.pais,
      nacional = this.state.nacional,
      direccion = this.state.direccion;

    // if (departamento !== "" && municipio === "") {
    //   this.handleLatLong(departamento);
    // }

    // if (departamento !== "" && municipio !== "") {
    //   this.handleLatLong(municipio + " " + departamento);
    // }

    // if (pais !== "") {
    //   this.handleLatLong(pais);
    // }

    if (nacional === "1" && municipio !== "" && departamento !== "") {
      this.handleLatLong(direccion + " " + municipio + " " + departamento);
    } else if (nacional === "0" && pais !== "") {
      this.handleLatLong(direccion + " " + pais);
    }
  }

  handleDepartamentos(e) {
    let depa = this.state.options_locations.departamentos.find(
      (d) => d.id.toString() === e.target.value
    );
    this.setState({
      departamento_id: e.target.value,
      departamento_name: depa.name,
      direccion: "",
    });
    this.handleLatLong(depa.name);
  }

  handleMunicipios(e) {
    let muni = this.state.options_locations.municipios.find(
      (d) => d.id.toString() === e.target.value
    );
    this.setState({
      municipio_id: e.target.value,
      municipio_name: muni.name,
      direccion: "",
    });
    if (this.state.departamento_id !== "") {
      this.handleLatLong(muni.name + "" + this.state.departamento_name);
    }
  }

  handlePais(e) {
    let pais = this.state.option_paises.find(
      (d) => d.descripcion === e.target.value
    );
    let lada = "+";
    if (pais.lada !== null) {
      lada = "+" + pais.lada;
    }

    this.setState({ pais: e.target.value, lada: lada });

    this.handleLatLong(e.target.value);
  }

  handleDireccion(e) {
    this.setState({ direccion: e.target.value.toUpperCase() });
    // if (
    //   this.state.nacional === "1" &&
    //   this.state.municipio_name !== "" &&
    //   this.state.departamento_name !== ""
    // ) {
    //   this.handleLatLong(
    //     e.target.value +
    //       " " +
    //       this.state.municipio_name +
    //       " " +
    //       this.state.departamento_name
    //   );
    // } else if (this.state.nacional === "0" && this.state.pais !== "") {
    //   this.handleLatLong(e.target.value + " " + this.state.pais);
    // }
  }

  handleActividades(e) {
    var act = [...this.state.actividades]; //copia del arreglo
    if (e.target.value !== "0" && !act.includes(e.target.value)) {
      //checamos que no se repitan elementos
      act.push(e.target.value);
    }
    this.setState({ actividades: act }); //volvemos a reescribir la variable
  }

  handleCondiciones(e) {
    var cond = [...this.state.condiciones]; //copia del arreglo
    if (e.target.value !== "0" && !cond.includes(e.target.value)) {
      //checamos que no se repitan elementos
      cond.push(e.target.value);
    }
    this.setState({ condiciones: cond }); //volvemos a reescribir la variable
  }

  handleRepresentante(e) {
    let rep = { ...this.state.representante_legal }; //hacemos una copia del objeto
    if (
      e.target.name === "nombres" ||
      e.target.name === "apellido_paterno" ||
      e.target.name === "apellido_materno" ||
      e.target.name === "direccion"
    ) {
      rep[e.target.name] = e.target.value.toUpperCase();
    } else if (e.target.name === "telefono") {
      if (this.validatePhoneNumber(e.target.value)) {
        rep[e.target.name] = e.target.value;
      }
    } else if (e.target.name === "numero_identificacion") {
      // if (this.validateIdentificationNumber(e.target.value)) {
      rep[e.target.name] = e.target.value;
      // }
    } else {
      rep[e.target.name] = e.target.value; //dependiendo del nombre del input cambia el valor
    }

    this.setState({ representante_legal: rep });
  }

  /* REGENTES */

  handleRegente(e) {
    let rep = { ...this.state.regente };
    rep[e.target.name] = e.target.value.toUpperCase();
    this.setState({ regente: rep });

    /*  if (e.target.name === "guid") {
      if (e.target.value.length === 4) {
        this.handleGuidRegente();
      }
    } */
  }

  removeReg(e) {
    let regentes = [...this.state.regentes];
    regentes.splice(e.target.id, 1);
    this.setState({ regentes: regentes });
  }

  handleTelefonoNacional(evt) {
    if (this.validatePhoneNumber(evt.target.value)) {
      this.setState({ telefono: evt.target.value });
    }
  }

  handleTelefonoExtranjero(evt) {
    if (this.validatePhoneNumber(evt.target.value, "extranjero")) {
      this.setState({ telefono: evt.target.value });
    }
  }

  handleAreaTotal = (e) => {
    if (this.checkPositiveFloats(e.target.value)) {
      this.setState({ area: e.target.value });
    }
  };

  checkPositiveFloats = (str) => {
    let regex = /^([0]?||[1-9]\d{0,2}(\d{3})*|([1-9]\d*))(\.\d{0,3})?$/,
      response = false;

    if (str === "" || regex.test(str)) {
      response = true;
    }

    return response;
  };

  validatePhoneNumber(char, phoneType = "nacional") {
    let regex = null;

    phoneType === "nacional"
      ? (regex = /^[0-9]{1,8}$/)
      : (regex = /^[0-9]{1,12}$/);

    if (char === "" || regex.test(char)) {
      return true;
    }

    return false;
  }

  validateIdentificationNumber(char) {
    let regex = /^\d+$/;

    if (char === "" || regex.test(char)) {
      return true;
    }

    return false;
  }

  handleGuidRegente() {
    let reg = {
      nombres: this.getid("nombres").value,
      apellido_paterno: this.getid("apellido_paterno").value,
      apellido_materno: this.getid("apellido_materno").value,
      guid: this.getid("guid").value,
      tipo_establecimiento_id: this.state.tipo_establecimiento_id,
      // NORMA cupo: actividad de la solicitud (4,7,26 no suman cupo)
      actividades:
        this.state.actividades && this.state.actividades.length > 0
          ? this.state.actividades
          : this.state.actividad_id
          ? [String(this.state.actividad_id)]
          : [],
      actividad_id: this.state.actividad_id
        ? this.state.actividad_id
        : this.state.actividades && this.state.actividades.length > 0
        ? this.state.actividades[0]
        : null,
    };

    if (
      reg.nombres === "" ||
      reg.apellido_paterno === "" ||
      reg.guid.length < 4
      //|| reg.apellido_materno === ""
    ) {
      /* Swal.fire({
          title:"Error",
          icon: "warning",
          text: "Favor de terminar de llenar la información",
          confirmButtonText: "Continuar",
        }) */
      return;
    }

    this.setState({ disabledR: true });
    /*  Api.loading(true); */

    Api.fetch("app/getRegenteForEstablishments", reg, "POST").then((data) =>
      this.handleExisteRegente(data)
    );
  }

  handleExisteRegente(data) {
    Api.loading(false);
    if (data.id) {
      if (
        data.tipo_regente_id === "2" &&
        (this.state.tipo_establecimiento_id === "1" ||
          this.state.tipo_establecimiento_id === "2")
      ) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar un regente acuerdo al tipo de establecimiento.",
          confirmButtonText: "Continuar",
        }).then((result) => {
          this.setState({ disabledR: false });
        });
      } else if (
        data.tipo_regente_id === "1" &&
        (this.state.tipo_establecimiento_id === "4" ||
          this.state.tipo_establecimiento_id === "3")
      ) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar un regente acuerdo al tipo de establecimiento.",
          confirmButtonText: "Continuar",
        }).then((result) => {
          this.setState({ disabledR: false });
        });
      } else {
        let reg = { ...this.state.regente };
        reg["regente_id"] = data.id;
        this.setState({ regente: reg });

        //this.setState({ existe_regente: true });

        let adr = document.querySelector("#addRegente");
        adr.classList = "btn btn-success";
        document.querySelector("#addRegente i").classList = "fas fa-check";

        adr.addEventListener(
          "click",
          (e) => {
            if (adr.classList === "btn btn-light") {
              return;
            }
            let reg = {
              nombres: this.getid("nombres").value,
              apellido_paterno: this.getid("apellido_paterno").value,
              apellido_materno: this.getid("apellido_materno").value,
              guid: this.getid("guid").value,
              id: data.id,
            };

            let regentes = this.state.regentes;
            //campos estan vacios entonces no agregamos
            if (
              reg.nombres !== "" &&
              reg.apellido_paterno !== "" &&
              reg.guid !== ""
            ) {
              for (let re in regentes) {
                if (
                  regentes[re].nombres === reg.nombres &&
                  regentes[re].apellido_paterno === reg.apellido_paterno &&
                  regentes[re].apellido_materno === reg.apellido_materno &&
                  regentes[re].guid === reg.guid
                ) {
                  Swal.fire({
                    title: "Atención",
                    icon: "warning",
                    text: "Ya cuenta con este regente en su lista.",
                    confirmButtonText: "Continuar",
                  }).then((result) => {
                    this.setState({ disabledR: false });
                    adr.classList = "btn btn-light";
                    document.querySelector("#addRegente i").classList =
                      "fa fa-th";
                  });
                  return false;
                }
              }

              regentes.push(reg);
              this.setState({ regentes: regentes });
              adr.classList = "btn btn-light";
              document.querySelector("#addRegente i").classList = "fa fa-th";

              let regente = {
                regente_id: "",
                nombres: "",
                apellido_paterno: "",
                apellido_materno: "",
                guid: "",
              };
              this.setState({ regente: regente, disabledR: false });
            }
          },
          { once: true }
        );
      }
    } else {
      if (data.message) {
        Swal.fire({
          title: "Error al ingresar regente",
          icon: "warning",
          text: data.message,
          confirmButtonText: "Continuar",
        }).then((result) => {
          this.setState({ disabledR: false });
        });
      } else {
        Swal.fire({
          title: "Error al ingresar regente",
          icon: "warning",
          text: "Favor de ingresar un regente disponible con licencia vigente.",
          confirmButtonText: "Continuar",
        }).then((result) => {
          this.setState({ disabledR: false });
        });
      }
    }
  }

  /*ESTABLECIMIENTOS RELACIONADOS */

  handleEstablecimiento(e) {
    let est = { ...this.state.establecimiento };
    est[e.target.name] = e.target.value.toUpperCase();
    this.setState({ establecimiento: est });

    /*     if (e.target.name === "guid") {
      if (e.target.value.length === 4) {
        this.handleGuidEstablecimiento();
      }
    } */
  }

  removeEst(e) {
    let establecimientos = [...this.state.establecimientos];
    establecimientos.splice(e.target.id, 1);
    this.setState({ establecimientos: establecimientos });
  }

  handleGuidEstablecimiento() {
    let est = {
      razon_social: this.getid("razon_social_e").value,
      guid: this.getid("guid_e").value,
      est_solicita_id: this.props.match.params["id"] 
    };

    if (est.razon_social === "" || est.guid === "") {
      return;
    }
    //Api.loading(true);
    Api.fetch("app/getValidEstablishment", est, "POST").then((data) =>
      this.handleExisteEstablecimiento(data)
    );
  }

  handleExisteEstablecimiento(data) {
    //Api.loading(false);

    if (data.id) {
      if (
        ((data.tipo_establecimiento_id === "4" ||  data.tipo_establecimiento_id === "3") &&
          (this.state.tipo_establecimiento_id === "1" || this.state.tipo_establecimiento_id === "2")) ||
        ((data.tipo_establecimiento_id === "1" || data.tipo_establecimiento_id === "2") &&
          (this.state.tipo_establecimiento_id === "4" ||  this.state.tipo_establecimiento_id === "3"))
      ) {
        Swal.fire({
          title: "Error",
          icon: "warning",
          text: "Favor de ingresar un establecimiento de acuerdo al tipo de establecimiento actual.",
        });
      } else {
        let est = { ...this.state.establecimiento };
        est["establecimiento_id"] = data.id;
        this.setState({ establecimiento: est });

        //this.setState({ existe_regente: true });

        let adr = document.querySelector("#addEst");
        adr.classList = "btn btn-success";
        document.querySelector("#addEst i").classList = "fas fa-check";

        adr.addEventListener(
          "click",
          (e) => {
            if (adr.classList === "btn btn-light") {
              return;
            }
            let est = {
              razon_social: this.getid("razon_social_e").value,
              guid: this.getid("guid_e").value,
              id: data.id,
            };

            //campos estan vacios entonces no agregamos
            if (est.razon_social !== "" && est.guid !== "") {
              let establecimientos = this.state.establecimientos;

              for (let re in establecimientos) {
                if (
                  establecimientos[re].razon_social === est.razon_social &&
                  establecimientos[re].guid === est.guid
                ) {
                  Swal.fire({
                    title: "Atención",
                    icon: "warning",
                    text: "Ya cuenta con este establecimiento en su lista.",
                  });
                  adr.classList = "btn btn-light";
                  document.querySelector("#addEst i").classList = "fa fa-th";
                  return false;
                }
              }

              establecimientos.push(est);
              this.setState({ establecimientos: establecimientos });
              adr.classList = "btn btn-light";
              document.querySelector("#addEst i").classList = "fa fa-th";

              let establecimiento = {
                establecimiento_id: "",
                razon_social: "",
                guid: "",
              };

              this.setState({ establecimiento: establecimiento });
            }
          },
          { once: true }
        );
      }
    } else {
      Swal.fire({
        title: "Error al ingresar el establecimiento",
        icon: "warning",
        text: "Favor de ingresar un establecimiento con licencia vigente.",
      });
      //this.setState({ existe_regente: false });
    }
  }

  /* WIZARD */

  handleStep(e) {
    //no te dejo pasar si no haz terminado el paso anterior
    var activo = this.state.activeStep;

    if (e.target.id === "") {
      return;
    }

    if (this.state.nacional === "1") {
      if (
        activo === "establecimiento" &&
        (e.target.id === "representante legal" ||
          e.target.id === "regente" ||
          e.target.id === "establecimientos relacionados" ||
          e.target.id === "características")
      ) {
        if (
          this.state.telefono === "" ||
          this.state.correo_electronico === "" ||
          this.state.razon_social === "" ||
          this.state.direccion === ""
        ) {
          if (
            (this.state.nacional === "1" &&
              (this.state.departamento_id === "" ||
                this.state.municipio_id === "")) ||
            (this.state.nacional === "0" && this.state.pais === "")
          ) {
            this.handleWarning();
          }
        } else {
          this.setState({
            activeStep: e.target.id,
          });
        }
      } else if (
        activo === "representante legal" &&
        (e.target.id === "establecimientos relacionados" ||
          e.target.id === "regente" ||
          e.target.id === "características")
      ) {
        if (this.state.representantes.length === 0) {
          this.handleWarning();
        } else {
          this.setState({
            activeStep: e.target.id,
          });
        }
      } else if (
        activo === "regente" &&
        (e.target.id === "establecimientos relacionados" ||
          e.target.id === "características")
      ) {
        if (this.state.regentes.length === 0) {
          this.handleWarning();
        } else {
          this.setState({
            activeStep: e.target.id,
          });
        }
        /*}  else if (
      this.state.activeStep == "establecimientos relacionados" && e.target.id == "características"
    ) {
      if (this.state.regentes.length == 0) {
        this.handleWarning();
      } else {
        this.setState({
          activeStep: e.target.id,
        });
      } */
      } else {
        this.setState({
          activeStep: e.target.id,
        });
      }
    } else {
      if (
        activo === "establecimiento" &&
        (e.target.id === "representante legal" ||
          e.target.id === "regente" ||
          e.target.id === "establecimientos relacionados")
      ) {
        if (
          this.state.telefono === "" ||
          this.state.correo_electronico === "" ||
          this.state.razon_social === "" ||
          this.state.direccion === ""
        ) {
          if (
            (this.state.nacional === "1" &&
              (this.state.departamento_id === "" ||
                this.state.municipio_id === "")) ||
            (this.state.nacional === "0" && this.state.pais === "")
          ) {
            this.handleWarning();
          }
        } else {
          this.setState({
            activeStep: e.target.id,
          });
        }
      } else if (
        activo === "representante legal" &&
        (e.target.id === "establecimientos relacionados" ||
          e.target.id === "regente")
      ) {
        if (this.state.representantes.length === 0) {
          this.handleWarning();
        } else {
          this.setState({
            activeStep: e.target.id,
          });
        }
      } else if (
        activo === "regente" &&
        e.target.id === "establecimientos relacionados"
      ) {
        if (this.state.regentes.length === 0) {
          this.handleWarning();
        } else {
          this.setState({
            activeStep: e.target.id,
          });
        }
        /*}  else if (
          this.state.activeStep == "establecimientos relacionados" && e.target.id == "características"
        ) {
          if (this.state.regentes.length == 0) {
            this.handleWarning();
          } else {
            this.setState({
              activeStep: e.target.id,
            });
          } */
      } else {
        this.setState({
          activeStep: e.target.id,
        });
      }
    }
  }

  handleWarning() {
    Swal.fire({
      title: "Llenar la pestaña actual antes de continuar",
      icon: "warning",
      text: "Revise que la información este completa.", //message,
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    //this.setState({ procesando: true });

    if (this.state.nacional === "1") {
      if (
        this.state.area === "" ||
        this.state.direccion_bodegas === "" ||
        this.state.condiciones.length === 0
      ) {
        this.handleWarning();
        return;
      }
    }

    //getting request ready for fetch (without options), must to be a shallow copy.
    let postData = { ...this.state };

    // shallow copy is inherit of the main state
    delete postData.options_establishments;
    delete postData.options_conditions;
    delete postData.options_activities;
    delete postData.options_locations;
    delete postData.options_identification;
    delete postData.option_paises;
    Api.loading(true);
    Api.fetch("app/establishmentInscription", postData, "POST")
      .then((data) => this.handleRegister(data))
      .catch((error) => {
        //return;
        error.json().then((message) => {
          this.setState({ procesando: false });
          Swal.fire({
            title: "Ocurrió un error al procesar la solicitud",
            icon: "error",
            text: "Revise la información e intente de nuevo su última acción", //message,
          });
        }); //catching errors to show notification
      });
  }

  getid(id) {
    return document.querySelector("#" + id);
  }

  handleRegister(e) {
    if (e.errors) {
      //|| e.exception
      let tplErrors = `Los siguientes campos son obligatorios: <u>`;

      for (let err in e.errors) {
        tplErrors += `<li>${err
          .replace("_id", "")
          .replace("_", " ")
          .toUpperCase()}</li>`;
      }
      tplErrors += `</u>`;
      Swal.fire({
        title: "Atención, verifique el formulario",
        icon: "error",
        html: tplErrors,
      });
      this.setState({ procesando: false });
      return false;
    } else {
      Swal.fire({
        title: "Solicitud Generada",
        icon: "success",
        text: "Su solicitud ha sido recibida exitosamente.",
        confirmButtonText: "Continuar",
      }).then((result) => {
        if (result.isConfirmed) {
          window.location = "/establecimientos/listado";
        }
        this.setState({ procesando: false });
      });
    }
  }

  handleLat(evt) {
    let latitud = evt.target.value,
      latitudVal = evt.target.value;

    if (latitud === "") {
      latitud = 0;
      latitudVal = "";
    }

    this.setState({ latitud: latitud, latitudVal: latitudVal });
  }

  handleLng(evt) {
    let longitud = evt.target.value,
      longitudVal = evt.target.value;

    if (longitud === "") {
      longitud = 0;
      longitudVal = "";
    }

    this.setState({ longitud: longitud, longitudVal: longitudVal });
  }

  handleLatLong(e) {
    Api.fetch("app/getLatLng?direccion=" + encodeURIComponent(e)).then(
      (data) => {
        if (data) {
          this.setState({ latitud: data.lat, longitud: data.lng });
          //Leaflet marker fix
          setTimeout(function () {
            try {
              document.querySelector(".leaflet-marker-pane > img").src =
                "https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png";
            } catch (e) {
              this.handleLatLong(e);
            }
          }, 100);
        }
      }
    );
  }

  maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  render() {
    if (this.state.nacional !== "") {
      Api.loading(false);
    } else {
      Api.loading(true);
    }

    return (
      <div>
        <div className="nav-wizards-container">
          <nav className="nav nav-wizards-1 mb-2">
            {this.state.wizzard.map((paso) => (
              <div
                onClick={this.handleStep}
                id={paso.titulo.toLowerCase()}
                key={paso.titulo}
                className="nav-item col"
              >
                <div
                  className={
                    this.state.activeStep === paso.titulo.toLowerCase()
                      ? "active nav-link"
                      : "nav-link disabled"
                  }
                >
                  <div className="nav-no">
                    {this.state.wizzard.indexOf(paso) + 1}
                  </div>
                  <div className="nav-text">{paso.titulo}</div>
                </div>
              </div>
            ))}
          </nav>
        </div>
        <div className="card">
          <div className="card-body">
            <div
              className={
                this.state.activeStep === "establecimiento" ? "" : "hide"
              }
            >
              <fieldset>
                <legend>Datos Generales</legend>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label>Nombre del establecimiento</label>
                    <span className="text-danger"> *</span>
                    <input
                      type="text"
                      name="razon_social"
                      value={this.state.razon_social}
                      //disabled={this.state.disabled}
                      maxLength="150"
                      autoComplete="off"
                      onChange={(e) =>
                        this.setState({
                          razon_social: e.target.value.toUpperCase(),
                        })
                      }
                      className="form-control m-b-5"
                      placeholder="Nombre del establecimiento"
                      //disabled={this.state.esBaja}
                      required
                    />
                  </div>
                  {/* NACIONAL */}
                  <div
                    className={
                      this.state.nacional === "0"
                        ? "hide"
                        : "form-group col-md-6"
                    }
                  >
                    <label>Teléfono Activo</label>
                    <span className="text-danger"> *</span>
                    <input
                      type="text"
                      name="text"
                      autoComplete="off"
                      value={this.state.telefono}
                      onChange={this.handleTelefonoNacional}
                      className="form-control"
                      maxLength="20"
                      // onInput={this.maxLengthCheck}
                      placeholder="Ingrese teléfono activo"
                      required
                    />
                  </div>
                  {/* EXTRANJERO */}
                  <div
                    className={
                      this.state.nacional === "0"
                        ? "form-group col-md-6"
                        : "hide"
                    }
                  >
                    <label>Teléfono Activo</label>
                    <span className="text-danger"> *</span>
                    <div className="row">
                      <div className="col-md-2">
                        <input
                          type="string"
                          name="lada"
                          autoComplete="off"
                          value={this.state.lada}
                          className="form-control "
                          placeholder="+"
                          readOnly={true}
                        />
                      </div>
                      <div className="col-md-10">
                        <input
                          type="text"
                          name="telefono"
                          autoComplete="off"
                          value={this.state.telefono}
                          onChange={this.handleTelefonoExtranjero}
                          className="form-control"
                          maxLength="20"
                          // onInput={this.maxLengthCheck}
                          placeholder="Ingrese teléfono activo"
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="form-group col-md-6">
                    <label>Correo Electrónico Activo</label>
                    <span className="text-danger"> *</span>
                    <input
                      type="email"
                      name="email"
                      autoComplete="off"
                      value={this.state.correo_electronico}
                      onChange={(e) =>
                        this.setState({
                          correo_electronico: e.target.value,
                        })
                      }
                      maxLength="200"
                      className="form-control"
                      placeholder="Ingrese correo electrónico"
                      required
                    />
                  </div>
                  <div className="form-group col-md-6">
                    <label>Cédula RUC</label>
                    <input
                      type="text"
                      name="numero_de_identificacion"
                      autoComplete="off"
                      maxLength="50"
                      value={this.state.numero_de_identificacion}
                      onChange={(e) =>
                        this.setState({
                          numero_de_identificacion: e.target.value,
                        })
                      }
                      className="form-control"
                      placeholder="Ingrese cédula RUC"
                      //disabled={this.state.esBaja}
                    />
                  </div>
                </div>
              </fieldset>
              <br />

              <div className="row">
                <fieldset
                  className="col-md-6"
                  style={{ borderRight: "3px solid #222" }}
                >
                  <legend>Ubicación</legend>
                  <div
                    id="departamento"
                    className={
                      this.state.nacional === "0"
                        ? "hide"
                        : "form-group col-md-12"
                    }
                  >
                    <label>Departamento</label>
                    <span className="text-danger"> *</span>
                    <select
                      onChange={this.handleDepartamentos}
                      name="departamento_id"
                      className="form-control m-b-5"
                      value={this.state.departamento_id}
                      //disabled={this.state.esBaja}
                    >
                      <option className="dropdown-item">
                        {" "}
                        -- Seleccione --
                      </option>
                      {this.state.options_locations.departamentos.map(
                        (option, index) => (
                          <option
                            key={index}
                            className="dropdown-item"
                            //key={option.id}
                            value={option.id}
                          >
                            {option.name}
                          </option>
                        )
                      )}
                    </select>
                  </div>
                  <div
                    id="municipio"
                    className={
                      this.state.nacional === "0"
                        ? "hide"
                        : "form-group col-md-12"
                    }
                  >
                    <label>Municipio</label>
                    <span className="text-danger"> *</span>
                    <select
                      onChange={this.handleMunicipios}
                      name="municipio_id"
                      className="form-control m-b-5"
                      value={this.state.municipio_id}
                      //disabled={this.state.esBaja}
                    >
                      <option className="dropdown-item">
                        {" "}
                        -- Seleccione --
                      </option>
                      {this.state.options_locations.municipios
                        .filter(
                          (e) => e.estado_id === this.state.departamento_id
                        )
                        .map((option, index) => (
                          <option
                            className="dropdown-item"
                            //data-nombre=
                            key={index}
                            value={option.id}
                          >
                            {option.name}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div
                    id="pais"
                    className={
                      this.state.nacional === "0"
                        ? "form-group col-md-12"
                        : "hide"
                    }
                  >
                    <label>País</label>
                    <span className="text-danger"> *</span>
                    <select
                      onChange={this.handlePais}
                      name="pais_id"
                      className="form-control m-b-5"
                      value={this.state.pais}
                      //disabled={this.state.esBaja}
                    >
                      <option className="dropdown-item">
                        {" "}
                        -- Seleccione --
                      </option>
                      {this.state.option_paises.map((option) => (
                        <option
                          className="dropdown-item"
                          key={option.id}
                          value={option.descripcion}
                        >
                          {option.descripcion}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group col-md-12">
                    <label>Dirección</label>
                    <span className="text-danger"> *</span>
                    <div className="input-group">
                      <input
                        type="text"
                        name="direccion_establecimiento"
                        autoComplete="off"
                        value={this.state.direccion}
                        onChange={this.handleDireccion}
                        className="form-control"
                        maxLength="200"
                        placeholder="Ingrese la dirección del establecimiento"
                        required
                      />
                      <div className="input-group-append">
                        <button
                          onClick={this.buscarUbicacion}
                          className="btn btn-outline-secondary"
                          type="button"
                          title="Buscar dirección"
                        >
                          <i
                            onClick={this.buscarUbicacion}
                            className="fa fa-search"
                          ></i>
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    className="row"
                    style={{ paddingLeft: "0.8em", paddingRight: "0.8em" }}
                  >
                    <div className="form-group col-md-6">
                      <label>Latitud</label>
                      <span className="text-danger"> *</span>
                      <input
                        type="number"
                        autoComplete="off"
                        value={this.state.latitudVal}
                        onChange={this.handleLat}
                        className="form-control "
                        placeholder="Latitud"
                        maxLength="255"
                        required
                      />
                    </div>
                    <div className="form-group col-md-6">
                      <label>Longitud</label>
                      <span className="text-danger"> *</span>
                      <input
                        type="number"
                        autoComplete="off"
                        value={this.state.longitudVal}
                        onChange={this.handleLng}
                        className="form-control "
                        placeholder="Longitud"
                        maxLength="255"
                        required
                      />
                    </div>
                  </div>
                </fieldset>

                <fieldset className="col-md-6">
                  <legend>Geo Referencia</legend>
                  <MapContainer
                    key={JSON.stringify([
                      parseFloat(this.state.latitud),
                      parseFloat(this.state.longitud),
                    ])}
                    style={{
                      height: "100%",
                      borderRadius: "6px",
                      boxShadow: "0px 0px 10px 0px rgba(0,0,0,.5)",
                    }}
                    center={[
                      parseFloat(this.state.latitud),
                      parseFloat(this.state.longitud),
                    ]}
                    zoom={17}
                    scrollWheelZoom={true}
                  >
                    <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <Marker
                      position={[this.state.latitud, this.state.longitud]}
                      //draggable="true"
                    >
                      <Popup>
                        {/* A pretty CSS3 popup. <br /> Easily customizable. */}
                      </Popup>
                    </Marker>
                  </MapContainer>
                </fieldset>

                {/*  <div className="col-md-12">
                  <div className="btn-group btn-group-justified pull-right">
                    <button className="btn btn-primary ">REGRESAR</button>
                    <button className="btn  btn-warning">REINICIAR</button> 
                    <button className="btn  btn-success ">
                      SIGUIENTE PASO
                    </button>
                  </div>
                </div> */}
              </div>
              <div className="text-right">
                {" "}
                Todos los campos con <span className="text-danger">*</span> son
                requeridos
              </div>
            </div>

            <div
              className={
                this.state.activeStep === "representante legal" ? "" : "hide"
              }
            >
              {/* == REPRESENTANTE LEGAL == */}
              <form id="frmRep">
                <fieldset>
                  <legend>Representante Legal</legend>
                  <div className="row">
                    <div className="form-group col-md-12">
                      <label>Nombres</label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="nombres"
                        value={this.state.representante_legal.nombres}
                        //disabled={this.state.disabled}
                        onChange={this.handleRepresentante}
                        className="form-control"
                        placeholder="Ingrese nombre(s)"
                        maxLength="30"
                        //disabled={this.state.esBaja}
                        required
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Apellido Paterno</label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="apellido_paterno"
                        value={this.state.representante_legal.apellido_paterno}
                        onChange={this.handleRepresentante}
                        className="form-control"
                        placeholder="Ingrese apellido paterno "
                        maxLength="20"
                        required
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Apellido Materno</label>
                      <input
                        type="text"
                        name="apellido_materno"
                        maxLength="20"
                        value={this.state.representante_legal.apellido_materno}
                        onChange={this.handleRepresentante}
                        className="form-control"
                        placeholder="Ingrese apellido materno "
                        //required
                      />
                    </div>

                    <div className="form-group col-md-12">
                      <label>Dirección</label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="direccion"
                        maxLength="200"
                        value={this.state.representante_legal.direccion}
                        onChange={this.handleRepresentante}
                        className="form-control"
                        placeholder="Ingrese dirección "
                        required
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Tipo de Identificación</label>
                      <span className="text-danger"> *</span>
                      <select
                        onChange={this.handleRepresentante}
                        name="tipo_documento_id"
                        className="form-control m-b-5"
                        value={this.state.representante_legal.tipo_documento_id}
                        //disabled={this.state.esBaja}
                      >
                        <option className="dropdown-item">Seleccione...</option>
                        {this.state.options_identification.tipo_identificacion.map(
                          (option) => (
                            <option
                              className="dropdown-item"
                              key={option.id}
                              value={option.id}
                            >
                              {option.descripcion}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    <div className="form-group col-md-6">
                      <label>Número de Identificación</label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        maxLength="80"
                        name="numero_identificacion"
                        value={
                          this.state.representante_legal.numero_identificacion
                        }
                        onChange={this.handleRepresentante}
                        className="form-control"
                        placeholder="Ingrese número de identificación "
                        required
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Teléfono Activo</label>
                      <span className="text-danger"> *</span>
                      <input
                        type="text"
                        name="telefono"
                        //pattern="[0-9]{4}[0-9]{4}"
                        maxLength="20"
                        // onInput={this.maxLengthCheck}
                        value={this.state.representante_legal.telefono}
                        onChange={this.handleRepresentante}
                        className="form-control"
                        placeholder="Ingrese teléfono activo "
                        required
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Correo Electrónico Activo</label>
                      <span className="text-danger"> *</span>
                      <input
                        type="email"
                        name="email"
                        maxLength="200"
                        value={this.state.representante_legal.email}
                        onChange={this.handleRepresentante}
                        className="form-control"
                        placeholder="Ingrese correo electrónico "
                        required
                      />
                    </div>

                    <div className="form-group col-md-6">
                      <label>Departamento</label>
                      <span className="text-danger"> *</span>
                      <select
                        onChange={this.handleRepresentante}
                        name="departamento_id"
                        className="form-control m-b-5"
                        value={this.state.representante_legal.departamento_id}
                        //disabled={this.state.esBaja}
                      >
                        <option className="dropdown-item">
                          {" "}
                          Seleccione...
                        </option>
                        {this.state.options_locations.departamentos.map(
                          (option, index) => (
                            <option
                              className="dropdown-item"
                              key={index}
                              value={option.id}
                            >
                              {option.name}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    <div className="form-group col-md-6">
                      <label>Municipio</label>
                      <span className="text-danger"> *</span>
                      <select
                        onChange={this.handleRepresentante}
                        name="municipio_id"
                        className="form-control m-b-5"
                        value={this.state.representante_legal.municipio_id}
                        //disabled={this.state.esBaja}
                      >
                        <option className="dropdown-item">Seleccione...</option>
                        {this.state.options_locations.municipios
                          .filter(
                            (e) =>
                              e.estado_id ===
                              this.state.representante_legal.departamento_id
                          )
                          .map((option) => (
                            <option
                              className="dropdown-item"
                              //key={option.id}
                              value={option.id}
                            >
                              {option.name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div
                      className="form-group col-md-12"
                      style={{ textAlign: "right" }}
                    >
                      <div onClick={this.addRep} className="btn btn-primary">
                        Agregar representante
                      </div>
                    </div>
                    <div
                      className="form-group col-md-12"
                      id="listaRepresentantes"
                    >
                      <table className="table table-striped m-b-0 table-hover">
                        <thead>
                          <tr>
                            <th>Nombre</th>
                            <th>Apellido paterno</th>
                            <th>Apellido materno</th>
                            <th>Correo electrónico</th>
                            <th>Ubicación</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.representantes.map((rep, index) => (
                            <tr key={index} id={"t" + index}>
                              <td>{rep.nombres}</td>
                              <td>{rep.apellido_paterno}</td>
                              <td>{rep.apellido_materno}</td>
                              <td>{rep.email}</td>
                              <td>{rep.ubicacion}</td>
                              <td>
                                <button
                                  id={index}
                                  onClick={this.removeRep}
                                  className="btn btn-warning"
                                >
                                  <i
                                    id={index}
                                    onClick={this.removeRep}
                                    className="fas fa-trash"
                                  ></i>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </fieldset>
              </form>
              <div className="text-right">
                {" "}
                Todos los campos con * son requeridos
              </div>
            </div>

            <div className={this.state.activeStep === "regente" ? "" : "hide"}>
              <fieldset>
                <legend>Regente</legend>
                <div className="row">
                  <div className="form-group col-md-12">
                    <label>Nombres:</label>
                    <span className="text-danger"> *</span>
                    <input
                      type="text"
                      name="nombres"
                      id="nombres"
                      maxLength="120"
                      onChange={this.handleRegente}
                      value={this.state.regente.nombres}
                      className="form-control"
                      placeholder="Ingrese nombre(s)"
                      disabled={this.state.disabledR}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Apellido Paterno:</label>
                    <span className="text-danger"> *</span>
                    <input
                      type="text"
                      name="apellido_paterno"
                      id="apellido_paterno"
                      maxLength="60"
                      value={this.state.regente.apellido_paterno}
                      onChange={this.handleRegente}
                      className="form-control"
                      placeholder="Ingrese apellido paterno "
                      disabled={this.state.disabledR}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <label>Apellido Materno:</label>

                    <input
                      type="text"
                      name="apellido_materno"
                      id="apellido_materno"
                      maxLength="60"
                      value={this.state.regente.apellido_materno}
                      onChange={this.handleRegente}
                      className="form-control"
                      placeholder="Ingrese apellido materno "
                      disabled={this.state.disabledR}
                      required
                    />
                  </div>

                  <div className="form-group col-md-3">
                    <label>GUID:</label>

                    <input
                      type="text"
                      name="guid"
                      id="guid"
                      onChange={this.handleRegente}
                      value={this.state.regente.guid}
                      className="form-control"
                      maxLength="4"
                      placeholder="Ingrese GUID "
                      disabled={this.state.disabledR}
                      required
                    />
                  </div>

                  <div className="col-md-3">
                    <br />
                    <div
                      id="addRegente"
                      onClick={this.handleGuidRegente}
                      className=" btn btn-light"
                    >
                      <i className="fa fa-th"></i>
                    </div>
                  </div>
                </div>
                <br />
                <div id="listaRegentes">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>Apellido paterno</th>
                        <th>Apellido materno</th>
                        <th>GUID</th>
                        <th>Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.regentes.map((reg, index) => (
                        <tr key={index} id={"t" + index}>
                          <td>{reg.nombres}</td>
                          <td>{reg.apellido_paterno}</td>
                          <td>{reg.apellido_materno}</td>
                          <td>{reg.guid}</td>
                          <td>
                            <button
                              id={index}
                              onClick={this.removeReg}
                              className="btn btn-warning"
                            >
                              <i
                                id={index}
                                onClick={this.removeReg}
                                className="fas fa-trash"
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </fieldset>

              <div className="text-right">
                {" "}
                Todos los campos con * son requeridos
              </div>
            </div>

            <div
              className={
                this.state.activeStep === "características" ? "" : "hide"
              }
            >
              <div className="row">
                <div className="form-group col-md-12">
                  <fieldset>
                    <legend>Características del Establecimiento</legend>
                    <div className="row">
                      <div className="form-group col-md-12">
                        <label>Área total(m²)</label>

                        <span className="text-danger">
                          {this.state.nacional === "0" ? "" : "*"}
                        </span>
                        <input
                          type="text"
                          name="area"
                          maxLength="8"
                          // onInput={this.maxLengthCheck}
                          value={this.state.area}
                          onChange={this.handleAreaTotal}
                          className="form-control"
                          placeholder="Ingrese el área total "
                          maxLength="50"
                          required
                        />

                        {/* <input
                      type="text"
                      placeholder="Ingrese el area total "
                      className="form-control"
                    /> */}
                      </div>
                      <div className="form-group col-md-12">
                        <label>Dirección de bodegas y almacenamiento</label>
                        <span className="text-danger">
                          {this.state.nacional === "0" ? "" : "*"}
                        </span>
                        <textarea
                          type="text"
                          name="direccion_bodegas"
                          value={this.state.direccion_bodegas}
                          onChange={(e) =>
                            this.setState({
                              direccion_bodegas: e.target.value.toUpperCase(),
                            })
                          }
                          maxLength="200"
                          className="form-control"
                          placeholder="Ingrese la dirección de bodegas y almacenamiento"
                          required
                        />

                        {/* <textarea
                      type="text"
                      placeholder="Ingrese la dirección"
                      className="form-control"
                    ></textarea> */}
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>

              <div className="row">
                <div className="form-group col-md-12">
                  <fieldset>
                    <legend>
                      Condiciones, equipos y medios disponibles (donde se
                      almacenan y distribuyen los productos)
                    </legend>
                    <span className="text-danger">
                      {this.state.nacional === "0" ? "" : "*"}
                    </span>

                    <table className="table table-striped m-b-0 table-hover">
                      <tbody>
                        {this.state.options_conditions.condiciones.map(
                          (option, index) => (
                            <tr key={index}>
                              <td>{option.descripcion}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  //checked={isSelected}
                                  value={option.id}
                                  onClick={this.handler}
                                  onChange={this.handleCondiciones}
                                  style={{ marginRight: "5px" }}
                                />
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </fieldset>
                  <div className="text-right">
                    {" "}
                    Todos los campos con <span className="text-danger">
                      *
                    </span>{" "}
                    son requeridos
                  </div>
                </div>
              </div>

              <div
                className={
                  this.state.procesando
                    ? "progress rounded-corner m-b-15"
                    : "hide"
                }
              >
                <div
                  className="progress-bar bg-purple progress-bar-striped progress-bar-animated"
                  style={{ width: "100%", height: "20px" }}
                >
                  <h4>Cargando, espere...</h4>
                </div>
              </div>

              <div
                className={this.state.procesando ? "hide" : "pull-right"}
              ></div>
              <br></br>

              <button
                type="submit"
                onClick={this.handleSubmit}
                className="col-md-12 btn btn-primary m-r-5"
              >
                Generar
              </button>
            </div>

            <div
              className={
                this.state.activeStep === "establecimientos relacionados"
                  ? ""
                  : "hide"
              }
            >
              <fieldset>
                <legend>Establecimientos relacionados</legend>
                <div className="row">
                  <div className="form-group col-md-6">
                    <label>Razón social</label>

                    <input
                      type="text"
                      name="razon_social"
                      id="razon_social_e"
                      maxLength="150"
                      onChange={this.handleEstablecimiento}
                      value={this.state.establecimiento.razon_social}
                      className="form-control"
                      placeholder="Ingrese razón social del establecimiento"
                      required
                    />

                    {/* <input
                      type="text"
                      value={this.state.representante_legal.nombres}
                      placeholder="Ingrese nombre "
                      className="form-control"
                    /> */}
                  </div>

                  <div className="form-group col-md-5">
                    <label>GUID</label>

                    <input
                      type="text"
                      name="guid"
                      id="guid_e"
                      onChange={this.handleEstablecimiento}
                      value={this.state.establecimiento.guid}
                      className="form-control"
                      maxLength="4"
                      placeholder="Ingrese GUID "
                      required
                    />
                  </div>

                  <div className="col-md-1">
                    <br />
                    <div
                      id="addEst"
                      onClick={this.handleGuidEstablecimiento}
                      className=" btn btn-light"
                    >
                      <i className="fa fa-th"></i>
                    </div>
                  </div>
                </div>
                <br />
                <div id="listaEstablecimientos">
                  <table className="table table-striped m-b-0 table-hover">
                    <thead>
                      <tr>
                        <th>Razón social</th>
                        <th>GUID</th>
                        <th>Acción</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.establecimientos.map((est, index) => (
                        <tr key={index} id={"t" + index}>
                          <td>{est.razon_social}</td>
                          <td>{est.guid}</td>
                          <td>
                            <button
                              id={index}
                              onClick={this.removeEst}
                              className="btn btn-warning"
                            >
                              <i
                                id={index}
                                onClick={this.removeEst}
                                className="fas fa-trash"
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </fieldset>

              <div className="text-right">
                {" "}
                Todos los campos con * son requeridos
              </div>
            </div>
          </div>

          {/*  

            <div
              className={
                this.state.activeStep === "equipo y medios" ? "" : "hide"
              }
            >
              <fieldset className="col-md-6">
                <legend>Equipo y Medios</legend>
                <div className="checkbox checkbox-css ">
                  <input type="checkbox" id="cssCheckbox1" defaultChecked />
                  <label htmlFor="cssCheckbox1">Elemento a</label>
                </div>
                <div className="checkbox checkbox-css">
                  <input type="checkbox" id="cssCheckbox1" defaultChecked />
                  <label htmlFor="cssCheckbox1">Elemento b</label>
                </div>
                <div className="checkbox checkbox-css">
                  <input type="checkbox" id="cssCheckbox1" defaultChecked />
                  <label htmlFor="cssCheckbox1">Elemento c</label>
                </div>
                <div className="checkbox checkbox-css ">
                  <input type="checkbox" id="cssCheckbox1" defaultChecked />
                  <label htmlFor="cssCheckbox1">Elemento d</label>
                </div>
              </fieldset>
            </div>

            <div
              className={
                this.state.activeStep === "documentación" ? "" : "hide"
              }
            >
              <fieldset className="col-md-12">
                <legend>Documentación</legend>
                <h4 className="m-b-10">
                  Adjuntar documentación requerida ({this.state.recs} de{" "}
                  {this.state.docsRequired.length}):
                </h4>

                <ol>
                  <li></li>
                </ol>

                <div className="note note-primary">
                  <div className="note-icon">
                    <i className="fas fa-file-pdf"></i>
                  </div>
                  <div className="note-content">
                    <h4>
                      <b>a</b>
                    </h4>
                    <p>b</p>
                  </div>
                  <div className="pull-right">
                    <i
                      onClick={this.handleDelete}
                      className="ion ion-md-close-circle fa-2x fa-fw pull-left m-r-10 text-red"
                    ></i>
                  </div>
                </div>

                <hr />
                <div className="form-group row col-md-9">
                  <label className="col-form-label col-md-5">
                    <select
                      onChange={this.handleTipoDocumento}
                      name="documento_id"
                      className="form-control m-b-5"
                    >
                      <option className="dropdown-item" value="0">
                        Seleccione tipo de documento...
                      </option>
                      
                        {this.state.options_documents.map((option) => (
                          <option
                            className="dropdown-item"
                            key={option.id}
                            value={option.id}
                          >
                            {option.descripcion}
                          </option>
                        ))} 
                    </select>
                  </label>
                  <div className="col-md-7" style={{ marginTop: "0.5%" }}>
                    <input
                      type="file"
                      className="btn btn-primary"
                      onChange={(e) => this.handleFile(e.target)}
                    />
                  </div>
                </div>
              </fieldset>
            </div> 
          </div>*/}
        </div>
      </div>
    );
  }
}

export default (props) => {
  const auth = useAuth();
  const history = useHistory();
  const match = useRouteMatch();
  return (
    <EstablishmentInscription
      auth={auth}
      history={history}
      match={match}
      {...props}
    />
  );
};
